import Navigation from "../components/Navigation";
import ActionSection from "../components/ActionSection";
import MediaSection from "../components/MediaSection";
import CampInformationSection from "../components/CampInformationalSection";
import Announcements from "../components/Announcements";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import "../styles/home.css";

export default function HomePage() {
  return (
    <div className="hsyc">
      <Navigation />
      <main>
        <ActionSection />
        <CampInformationSection section_name={"wintercamp"} />
        <MediaSection />
        <Announcements />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
